import Link from 'next/link'

import { cn } from '@/lib/utils'

import { Icons } from '@/components/icons'
import { Button } from '@/components/ui/button'

import { HeaderActionConfig } from '@/types/header-footer-config'

interface HeaderRightActionsProps {
  actions: HeaderActionConfig[]
  className?: string
}

export default function HeaderRightActions({ actions, className }: HeaderRightActionsProps) {
  if (!actions.length) return null

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {actions.map(action => {
        const Icon = action.icon && action.icon in Icons ? Icons[action.icon as keyof typeof Icons] : null
        const commonProps = action.external ? { target: '_blank', rel: 'noopener noreferrer' } : {}

        if (action.type === 'icon') {
          return (
            <Button key={`${action.label}-${action.href}`} asChild size="icon" variant={action.variant ?? 'ghost'}>
              <Link href={action.href} aria-label={action.label} {...commonProps}>
                {Icon ? <Icon className="size-4" /> : <span className="text-xs font-medium">{action.label}</span>}
              </Link>
            </Button>
          )
        }

        return (
          <Button
            key={`${action.label}-${action.href}`}
            asChild
            size={action.type === 'button' ? 'default' : 'sm'}
            variant={action.variant ?? (action.type === 'button' ? 'default' : 'link')}
            className={action.type === 'link' ? 'px-0' : undefined}
          >
            <Link href={action.href} {...commonProps}>
              {Icon && <Icon className="size-4" />}
              {action.label}
            </Link>
          </Button>
        )
      })}
    </div>
  )
}
